import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth/AuthProvider.tsx';
import { LoginForm } from '@/components/auth/LoginForm.tsx';
import { UserRole } from '@/types/auth.ts';

export function LoginPage() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    // planTEK: EXTERNAL role users land on /my-views, not the internal dashboard
    if (user?.role === UserRole.EXTERNAL) {
      return <Navigate to="/my-views" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="text-center text-3xl font-bold text-gray-900 mb-8">
          BuildGravity Platform
        </h1>
        <LoginForm onSuccess={() => {/* Redirect handled by Navigate above */}} />
      </div>
    </div>
  );
}